import { render, staticRenderFns } from "./CalculatedPriceList.vue?vue&type=template&id=5884fd4a&scoped=true"
import script from "./CalculatedPriceList.vue?vue&type=script&lang=js"
export * from "./CalculatedPriceList.vue?vue&type=script&lang=js"
import style0 from "./CalculatedPriceList.vue?vue&type=style&index=0&id=5884fd4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884fd4a",
  null
  
)

export default component.exports